export const DUPLICATED_PREFIX = 'duplicated-';

const generateQuestionFormName = (uuid, isFormCloned) =>
  `${isFormCloned ? DUPLICATED_PREFIX : ''}question-form-${uuid}`;

export default generateQuestionFormName;
